import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import { GridConfig } from '../../../styles/Grid/GridSizes';

export const containerMarginCss = {
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
};

export const eyebrow = css(typography.effra18, {
  marginBottom: 8,
  color: colorsPalette.grey80,
});

export const headline = css(typography.effra48, {
  position: 'relative',
  colors: colorsPalette.grey,
  fontWeight: fontWeights.medium,
  marginBottom: 32,
  [MediaQueries.md]: {
    marginBottom: 24,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 41,
  },
});

export const description = css(typography.effra18, {
  marginBottom: 32,
  color: colorsPalette.grey80,
  [MediaQueries.md]: {
    marginBottom: 0,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 72,
  },
});

export const amenityItem = css(typography.effra16, {
  marginBottom: 24,
  display: 'flex',
  alignItems: 'flex-start',

  '&:last-child': {
    marginBottom: 0,
  },
  [MediaQueries.mdAndUp]: {
    width: '50%',
    '&:nth-last-of-type(2)': {
      '&:nth-of-type(odd)': {
        marginBottom: 0,
      },
    },
  },
  [MediaQueries.md]: {
    '&:nth-of-type(even)': {
      paddingLeft: `${GridConfig.md.gutter / 2}px`,
    },
  },
  [MediaQueries.lg]: {
    '&:nth-of-type(even)': {
      paddingLeft: `${GridConfig.lg.gutter / 2}px`,
    },
  },
  [MediaQueries.xl]: {
    '&:nth-of-type(even)': {
      paddingLeft: `${GridConfig.xl.gutter / 2}px`,
    },
  },
});

export const amenityList = css({
  marginBottom: 44,
  [MediaQueries.md]: {
    marginTop: 40,
    marginBottom: 50,
  },
  [MediaQueries.lgAndUp]: {
    position: 'relative',
    marginBottom: 0,
  },
});

export const amenityListLine = css({
  [MediaQueries.lgAndUp]: {
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '-90px',
      width: '100%',
      left: 0,
      height: 1,
      borderBottom: `1px solid ${colorsPalette.grey10}`,
    },
  },
});

export const columnContainer = css({
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});

export const grayContainer = css({
  backgroundColor: colorsPalette.brown10,
  padding: '25px 36px 50px',
  position: 'relative',
  width: '100%',
  [MediaQueries.sm]: {
    minHeight: 211,
  },
  [MediaQueries.lg]: {
    minHeight: 180,
    paddingLeft: 14,
    paddingRight: 14,
  },
});

export const previewImageStyleImage = css({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: '0',
  left: '0',
});

export const previewImageStyleIcon = css({
  width: '100%',
  height: '100%',
  top: '0',
  left: '0',
  display: 'block',
  img: {
    width: '100%',
    height: '100%',
    display: 'block',
  },
});

export const previewImgContainer = css({
  width: '100%',
  paddingTop: '75%',
  position: 'relative',
  marginBottom: 8,
  img: {
    width: '100%',
    height: '100%',
  },
});

export const listPreview = css({
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  [MediaQueries.mdAndUp]: {
    overflowX: 'visible',
    flexWrap: 'wrap',
  },
});

export const itemPreview = css({
  paddingLeft: 10,
  '&:nth-of-type(1)': {
    paddingLeft: 0,
  },
});

export const textPreview = css(typography.effra14, {
  bottom: 16,
  color: colorsPalette.grey80,
  left: 0,
  padding: '0 20px',
  position: 'absolute',
  textAlign: 'center',
  width: '100%',
  [MediaQueries.lg]: {
    lineHeight: 1.15,
  },
});

export const previewContainer = css({
  overflowX: 'auto',
  [MediaQueries.mdAndUp]: {
    overflowX: 'visible',
  },
});

export const columnContainerCss = css({
  flex: '0 0 auto',
  [MediaQueries.mdAndUp]: {
    '&:nth-of-type(1)': {
      marginBottom: 24,
    },
    '&:nth-of-type(3)': {
      li: {
        borderBottomLeftRadius: 30,
        overflow: 'hidden',
      },
    },
  },
  [MediaQueries.lgAndUp]: {
    width: '50%',
  },
});

export const iconContainerCss = css({
  width: 18,
  height: 18,
  margin: '3px 19px 0',
  [MediaQueries.mdAndUp]: {
    margin: '3px 25px 0',
  },
});

export const changeDirectionCss = css({
  [MediaQueries.lgAndUp]: {
    flexDirection: 'row-reverse',
  },
});
